<template>
  <v-col cols="12" class="d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-btn icon="mdi-chevron-left" @click="$emit('back')" variant="elevated" :density="$vuetify.display.mdAndUp ? 'compact' : 'comfortable' " color="primary"></v-btn>
      <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">{{title}}</h2>
      <h3 class="mx-3" v-else>{{title}}</h3>
    </div>
    <div class="d-flex align-center justify-end" >
      <v-btn v-if="!disableSave && $vuetify.display.mdAndUp" append-icon="mdi-content-save" @click="$emit('saveback')" size="small" class="mr-3" color="primary" :disabled="loading" :loading="loading">Salva e indietro</v-btn>
      <v-btn v-if="!disableSave && $vuetify.display.mdAndUp" append-icon="mdi-content-save" type="submit" size="small" color="primary" :disabled="loading" :loading="loading">Salva</v-btn>
      <v-btn v-if="!disableSave && $vuetify.display.smAndDown" icon="mdi-content-save" type="submit" size="small" color="primary" :disabled="loading" :loading="loading"></v-btn>
      <slot name="default"></slot>
    </div>
  </v-col>
  <v-col cols="12">
    <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
    <v-divider class="mb-3" v-else></v-divider>
  </v-col>
</template>

<script lang="ts">
export default {
  props : {
    title : {
      type: String,
      required: true
    },
    loading : {
      type : Boolean,
      default: false
    },
    disableSave : {
      type : Boolean,
      default: false
    }
  },
  emits : ['back', 'saveback'],
  setup(props, ctx) {
    return {}
  }
}
</script>

<style scoped>

</style>
